import { render, staticRenderFns } from "./OverlaySlide.vue?vue&type=template&id=c76564e0&"
import script from "./OverlaySlide.vue?vue&type=script&lang=js&"
export * from "./OverlaySlide.vue?vue&type=script&lang=js&"
import style0 from "./OverlaySlide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports